import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function NavBar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Avances',
    href: '#hitos'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }, {
    name: 'Noticias',
    href: '#noticias'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-bone/95 backdrop-blur-sm shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-303" data-mp="25tdz4lhdbqkm">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 flex justify-between items-center" data-id="element-304" data-mp="3havtiud27duh">
        <a href="#inicio" className="flex items-center" aria-label="TEFOS · Inicio" data-id="element-305" data-mp="1bx239hnpmoad">
          <img src="https://cdn.magicpatterns.com/uploads/krogWKC6bDwbBogQ4HpBCV/TEFOS_LOGO.png" alt="TEFOS — El bosque es futuro" className={`h-9 md:h-10 w-auto transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`} data-id="element-306" data-mp="1gv3oa84p4xoh" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-307" data-mp="1ptnxmiod9v01">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium tracking-wide transition-colors hover:text-clay ${isScrolled ? 'text-charcoal' : 'text-bone/90'}`} data-id="element-308" data-mp="t3oejualbe37">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-309" data-mp="16xxvmvgfoym5">
          {isMobileMenuOpen ? <X className={isScrolled ? 'text-charcoal' : 'text-bone'} data-id="element-310" data-mp="9h8t0zjntsbp" /> : <Menu className={isScrolled ? 'text-charcoal' : 'text-bone'} data-id="element-311" data-mp="eg3d04td5mxe" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-312" data-mp="1hq7qhsi749n5">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-bone shadow-lg md:hidden flex flex-col" data-id="element-313" data-mp="1cspeft8vteax">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="px-6 py-4 text-charcoal font-medium border-b border-bone-dark" data-id="element-314" data-mp="yswrm90h7i88">
                {link.name}
              </a>)}
          </motion.div>}
      </AnimatePresence>
    </header>;
}